import React from 'react'
import axios from 'axios'
import { Link } from 'react-router-dom'
import {
  Breadcrumb,
  BreadcrumbItem,
  Button,
  FormGroup,
  Input, Table,
  Row, Col, Modal, Form, ModalHeader, ModalBody, Label, ModalFooter, Collapse
} from "reactstrap";
import jwt from "jsonwebtoken";
import {USER_ROLE} from "../../constants";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from "moment";
import { Country } from "country-state-city";
import Select from 'react-select';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
const fileReader = new FileReader();
const urlParams = new URLSearchParams(window.location.search);
const keySelected = urlParams.get('role');
class ManagePricingDetailDetail extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      data: [],
      modalToggle: false,
      modalEditToggle: false,
      modalToggleUpdatePricing: false,
      modalPricingInfo: {},
      currUser: {},
      fromDate: '',
      toDate: '',
      createPricing: {
        name: "",
        note: "",
      },
      editPricing: {
        name: "",
        note: "",
      },
      isEdit: false,
      loading: false,
      search: '',
      pricingType: "",
      images: [],
      imagesEdit: [],
      searchType: "owner",
      moneyPricingDetail: {},
      keySelected: keySelected || 'Sale',
      servicePricingItem: {},
      services: [],
      zones: [],
      selectedZone: null,
      modalZoneToggle: false,
      modalZoneEditToggle: false,
      serviceZones: {}, // Store zones for each service
      selectedServiceForZone: null,
      createZone: {
        name: "",
        countries: [],
        note: ""
      },
      editZone: {
        id: null,
        name: "",
        countries: [],
        note: ""
      },
      showZoneManagement: false,
      CountriesOptions: [],
      zonePricing: {}, // Store pricing data for each zone: { zoneId: pricingData }
      collapsedSections: {}, // Store collapse state for each service: { serviceName: boolean }
      collapsedZones: {}, // Store collapse state for each zone: { zoneId: boolean }
      collapsedDefaultPricing: {}, // Store collapse state for default pricing: { serviceName: boolean }
      serviceSearchTerm: '', // Search term for filtering services
      modalImportCSVToggle: false,
      importCSVServiceName: '',
      importCSVServiceType: '',
      importCSVFile: null,
      importCSVLoading: false,
      importCSVResult: null,
    }
    this.openEditModal = this.openEditModal.bind(this)
    this.onEditPricing = this.onEditPricing.bind(this)
    this.onCreatePricing = this.onCreatePricing.bind(this);
    this.onEditPricingChange = this.onEditPricingChange.bind(this);
    this.toggleUpdatePricing = this.toggleUpdatePricing.bind(this);
    this.onCreatePricingChange = this.onCreatePricingChange.bind(this);
    this.handleDatefromSelect = this.handleDatefromSelect.bind(this);
    this.handleDatetoSelect2 = this.handleDatetoSelect2.bind(this);
    this.toggle = this.toggle.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.searchBy = this.searchBy.bind(this);
    this.onChange2 = this.onChange2.bind(this);
    this.setImages = this.setImages.bind(this);
    this.onChooseFile = this.onChooseFile.bind(this);
    this.uploadMoneyPricing = this.uploadMoneyPricing.bind(this);
    this.setKey = this.setKey.bind(this);
    this.onUpdateServicePricingJSON = this.onUpdateServicePricingJSON.bind(this);
    this.onUpdateServicePricing = this.onUpdateServicePricing.bind(this);
    this.getJSONData = this.getJSONData.bind(this);
    this.toggleZoneModal = this.toggleZoneModal.bind(this);
    this.toggleZoneEditModal = this.toggleZoneEditModal.bind(this);
    this.onCreateZone = this.onCreateZone.bind(this);
    this.onEditZone = this.onEditZone.bind(this);
    this.onCreateZoneChange = this.onCreateZoneChange.bind(this);
    this.onEditZoneChange = this.onEditZoneChange.bind(this);
    this.getZonesByService = this.getZonesByService.bind(this);
    this.openZoneEditModal = this.openZoneEditModal.bind(this);
    this.onDeleteZone = this.onDeleteZone.bind(this);
    this.getZonesByServiceName = this.getZonesByServiceName.bind(this);
    this.selectZoneForService = this.selectZoneForService.bind(this);
    this.onCreateZoneCountryChange = this.onCreateZoneCountryChange.bind(this);
    this.onEditZoneCountryChange = this.onEditZoneCountryChange.bind(this);
    this.getZonePricing = this.getZonePricing.bind(this);
    this.loadZonePricingForAllZones = this.loadZonePricingForAllZones.bind(this);
    this.toggleSectionCollapse = this.toggleSectionCollapse.bind(this);
    this.toggleZoneCollapse = this.toggleZoneCollapse.bind(this);
    this.toggleDefaultPricingCollapse = this.toggleDefaultPricingCollapse.bind(this);
    this.initializeDefaultPricingCollapse = this.initializeDefaultPricingCollapse.bind(this);
    this.onServiceSearchChange = this.onServiceSearchChange.bind(this);
    this.clearServiceSearch = this.clearServiceSearch.bind(this);
    this.toggleImportCSVModal = this.toggleImportCSVModal.bind(this);
    this.openImportCSVModal = this.openImportCSVModal.bind(this);
    this.onImportCSV = this.onImportCSV.bind(this);
  }

  async componentDidMount() {
    let token = localStorage.getItem('id_token')
    let currUser = jwt.decode(token)

    // Initialize country options for multi-select
    const CountriesOptions = Country.getAllCountries().map(country => ({
      value: country.isoCode,
      label: `${country.name} - ${country.isoCode}`
    }))

    await this.setState({
      currUser, 
      createPricing: {...this.state.createPricing, owner: currUser.displayName},
      CountriesOptions
    })
    await this.getAllService()
    await this.getMoneyPricingById()
    await this.getAllServicePricing()
    
    // Initialize default pricing sections collapse state after data is loaded
    await this.initializeDefaultPricingCollapse()
    
    // Load zones for all services that contain 'TP'
    const tpServices = this.state.services.filter(service => 
      service.name.includes('TP') || service.name.includes('RG - AU') || service.name.includes('RG-AU')
    )
    
    for (const service of tpServices) {
      await this.getZonesByServiceName(service.name)
    }
  }

  async getMoneyPricingById(params = {}) {
    try {
      let { moneyPricingId } = this.props.match.params;
      const res = await axios.get(`/get-money-pricing/${moneyPricingId}`, )
      if (res && res.data) {
        this.setState({moneyPricingDetail: res.data})
      }
    } catch (e) {
      console.error(e)
    }
  }

  async getAllServicePricing(params = {}) {
    try {
      let { moneyPricingId } = this.props.match.params;
      this.setState({loading: true})
      let url = `/get-all-service-pricing?moneyPricingId=${moneyPricingId}`
      const res = await axios.get(url)
      if (res && res.data) {
        console.log(res.data)
        this.setState({data: res.data})
      }
      this.setState({loading: false})
    } catch (e) {
      console.error(e)
      this.setState({loading: false})
    }
  }

  async onCreatePricing(e) {
    try {
      let {createPricing} = this.state
      await axios.post('/create-money-pricing', {
        ...createPricing,
        fromDate: this.state.fromDate,
        toDate: this.state.toDate,
      })
      this.setState((prevState) => ({modalToggle: !prevState.modalToggle}));
      await this.getAllPricing()
      e.preventDefault();
    } catch (err) {
      let message = err.response.data.message || 'Đã có lỗi xảy ra!'
      toast.error(message);
    }
  }

  async onUpdateServicePricing(e) {
    try {
      let {servicePricingItem} = this.state
      await axios.post(`/update-service-pricing/${servicePricingItem.id}`, {
        ...servicePricingItem
      })
      this.setState((prevState) => ({modalToggle: !prevState.modalToggle}));
      await this.getAllServicePricing()
      e.preventDefault();
    } catch (err) {
      let message = err.response.data.message || 'Đã có lỗi xảy ra!'
      toast.error(message);
    }
  }

  async onEditPricing(e) {
    try {
      const {editPricing} = this.state
      await axios.post(`/update-money-pricing/${editPricing.id}`, {
        ...editPricing,
        fromDate: this.state.fromDate,
        toDate: this.state.toDate,
      })
      this.setState((prevState) => ({modalEditToggle: !prevState.modalEditToggle, images: [], imagesEdit: []}));
      await this.getAllPricing()
      e.preventDefault();
    } catch (e) {

    }
  }
  handleDatefromSelect(date) {
    this.setState({fromDate: date});
  }
  handleDatetoSelect2(date) {
    this.setState({toDate: date});
  }


  toggle(item) {
    this.setState((prevState, props) => ({modalToggle: !prevState.modalToggle}));
    if (item) this.setState({servicePricingItem: item})
  }

  openEditModal(obj) {
    this.setState({editPricing: obj, fromDate: new Date(obj.fromDate), toDate: new Date(obj.toDate)})
    this.setState((prevState, props) => ({modalEditToggle: !prevState.modalEditToggle}));
  }

  toggleUpdatePricing() {

  }

  onCreatePricingChange(e) {
    const {name, value} = e.target;
    let createPricingInfo = this.state.createPricing

    createPricingInfo[name] = value
    this.setState({createPricing: createPricingInfo})
  }

  onEditPricingChange(e) {
    const {name, value} = e.target;
    let editPricingInfo = this.state.editPricing
    editPricingInfo[name] = value
    this.setState({editPricing: editPricingInfo})
  }

  formatNumber(num) {
    if (num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
    }
    return 0
  }

  formatKey(key) {
    return parseFloat(key).toFixed(1)
  }

  onSelectChange = (e) => {
    const {value} = e
    this.setState({filterDateType: value})
  }

  searchBy(val) {
    this.setState({pricingType: val})
  }
  searchByCode(val) {
    this.setState({searchType: val})
  }

  async getAllPricing(params = {}) {
    try {
      this.setState({loading: true})
      let url = `/get-all-money-pricing?page=${params.page || 1}`
      const res = await axios.get(url)
      if (res && res.data) {
        console.log(res.data)
        this.setState({data: res.data})
      }
      this.setState({loading: false})
    } catch (e) {
      console.error(e)
      this.setState({loading: false})
    }
  }

  handlePageChange(pageNumber) {
    if (pageNumber === this.state.data.page) return
    this.getAllPricing({page: pageNumber})
  }

  checkPermission() {
    try {
      const role = this.state.currUser.role
      if (role === USER_ROLE.ADMIN || role === USER_ROLE.SALER | role === USER_ROLE.MANAGER || role === USER_ROLE.CONSULTANT || role === USER_ROLE.OPS) {
        return true
      }
      return false
    } catch (e) {
    }
  }

  checkPermission2() {
    try {
      const role = this.state.currUser.role
      if (role === USER_ROLE.ADMIN || role === USER_ROLE.MANAGER || role === USER_ROLE.CUSTOMER) {
        return true
      }
      return false
    } catch (e) {
    }
  }

  handleInput = (e) => {
    const {value} = e.target
    this.setState({search: value})
  }
  onSearch = (e) => {
    this.getAllPricing({search: this.state.search})
  }

  async getAllService(params = {}) {
    try {
      let url = `/get-all-service?limit=1000`
      const res = await axios.get(url)
      if (res && res.data) {
        this.setState({services: res.data?.list})
        // Check if any service is TP-EU to show zone management
        const hasTPEUService = res.data?.list?.some(service => 
          service.name.includes('TP-EU') || service.name.includes('TP - EU')
        )
        this.setState({showZoneManagement: hasTPEUService})
      }
    } catch (e) {
      console.error(e)
    }
  }

  // Zone Management Methods
  async getZonesByService(serviceId) {
    try {
      const res = await axios.get(`/zones/service/${serviceId}`)
      this.setState({ zones: res.data })
    } catch (error) {
      console.error('Error fetching zones:', error)
    }
  }

  async getZonesByServiceName(serviceName) {
    try {
      const priceType = this.state.keySelected?.toUpperCase() || 'SALE'
      const res = await axios.get(`/zones/service-name/${serviceName}?priceType=${priceType}`)
      this.setState(prevState => ({
        serviceZones: {
          ...prevState.serviceZones,
          [serviceName]: res.data
        }
      }))
      
      // Load pricing for all zones of this service
      if (res.data && res.data.length > 0) {
        await this.loadZonePricingForService(res.data)
      }
    } catch (error) {
      console.error('Error fetching zones for service:', error)
    }
  }

  async getZonePricing(zoneId) {
    try {
      const priceType = this.state.keySelected?.toUpperCase() || 'SALE'
      const { moneyPricingId } = this.props.match.params
      const res = await axios.get(`/service-pricing/zone/${zoneId}?priceType=${priceType}&moneyPricingId=${moneyPricingId}`)
      return res.data
    } catch (error) {
      console.error(`Error fetching pricing for zone ${zoneId}:`, error)
      return null
    }
  }

  async loadZonePricingForService(zones) {
    try {
      const zonePricingData = { ...this.state.zonePricing }
      
      for (const zone of zones) {
        const pricingData = await this.getZonePricing(zone.id)
        if (pricingData) {
          zonePricingData[zone.id] = pricingData
        }
      }
      
      this.setState({ zonePricing: zonePricingData })
    } catch (error) {
      console.error('Error loading zone pricing:', error)
    }
  }

  async loadZonePricingForAllZones() {
    try {
      const allZones = []
      // Collect all zones from all services
      Object.values(this.state.serviceZones).forEach(zones => {
        allZones.push(...zones)
      })
      
      if (allZones.length > 0) {
        await this.loadZonePricingForService(allZones)
      }
    } catch (error) {
      console.error('Error loading all zone pricing:', error)
    }
  }

  toggleSectionCollapse(serviceName) {
    this.setState(prevState => ({
      collapsedSections: {
        ...prevState.collapsedSections,
        [serviceName]: !prevState.collapsedSections[serviceName]
      }
    }))
  }

  toggleZoneCollapse(zoneId) {
    this.setState(prevState => ({
      collapsedZones: {
        ...prevState.collapsedZones,
        [zoneId]: !prevState.collapsedZones[zoneId]
      }
    }))
  }

  toggleDefaultPricingCollapse(serviceName) {
    this.setState(prevState => ({
      collapsedDefaultPricing: {
        ...prevState.collapsedDefaultPricing,
        [serviceName]: !prevState.collapsedDefaultPricing[serviceName]
      }
    }))
  }

  async initializeDefaultPricingCollapse() {
    const { services, data } = this.state
    const collapsedDefaultPricing = {}
    const collapsedSections = {}
    
    // Get price array to check if services have data
    const priceArr = this.getPriceArr(data)
    
    services.forEach(service => {
      // Find if this service has pricing data
      const serviceData = priceArr?.find(item => item.name === service.name)
      const hasData = serviceData?.hasData || false
      
      // If has data, set collapsed to true (collapsed by default)
      // If no data, the section won't render at all
      if (hasData) {
        collapsedDefaultPricing[service.name] = true
      }
      // Also collapse zone sections by default
      collapsedSections[service.name] = true
    })
    
    this.setState({ 
      collapsedDefaultPricing,
      collapsedSections 
    })
  }

  onServiceSearchChange(e) {
    this.setState({ serviceSearchTerm: e.target.value })
  }

  clearServiceSearch() {
    this.setState({ serviceSearchTerm: '' })
  }

  selectZoneForService(serviceName) {
    this.setState({
      selectedServiceForZone: serviceName
    }, () => {
      this.toggleZoneModal()
    })
  }

  toggleZoneModal() {
    this.setState(prevState => ({ modalZoneToggle: !prevState.modalZoneToggle }))
  }

  toggleZoneEditModal() {
    this.setState(prevState => ({ modalZoneEditToggle: !prevState.modalZoneEditToggle }))
  }

  async onCreateZone(e) {
    try {
      const { createZone } = this.state
      if (!createZone.name) {
        toast.error('Tên zone không được để trống!')
        return
      }
      if (!createZone.countries || createZone.countries.length === 0) {
        toast.error('Phải chọn ít nhất một quốc gia!')
        return
      }

      // Get the selected service for zone creation
      const selectedService = this.state.services.find(service => 
        service.name === this.state.selectedServiceForZone
      )
      
      if (!selectedService) {
        toast.error('Không tìm thấy dịch vụ được chọn!')
        return
      }

      // Get priceType based on keySelected value
      const priceType = this.state.keySelected?.toUpperCase() || 'SALE'

      await axios.post('/api/zones', {
        ...createZone,
        serviceId: selectedService.id,
        priceType: priceType
      })
      
      this.setState({ 
        modalZoneToggle: false,
        createZone: { name: "", countries: [], note: "" },
        selectedServiceForZone: null
      })
      await this.getZonesByServiceName(selectedService.name)
      toast.success('Tạo zone thành công!')
      e.preventDefault()
    } catch (error) {
      toast.error('Lỗi khi tạo zone!')
      console.error('Error creating zone:', error)
    }
  }

  async onEditZone(e) {
    try {
      const { editZone } = this.state
      // Get priceType based on keySelected value
      const priceType = this.state.keySelected?.toUpperCase() || 'SALE'
      
      await axios.put(`/api/zones/${editZone.id}`, {
        name: editZone.name,
        countries: editZone.countries,
        note: editZone.note,
        priceType: priceType
      })
      
      this.setState({ 
        modalZoneEditToggle: false,
        editZone: { id: null, name: "", countries: [], note: "" }
      })
      
      // Refresh zones for the service that owns this zone
      const zoneService = this.state.services.find(service => {
        const serviceZones = this.state.serviceZones[service.name] || []
        return serviceZones.some(z => z.id === editZone.id)
      })
      if (zoneService) {
        await this.getZonesByServiceName(zoneService.name)
      }
      
      toast.success('Cập nhật zone thành công!')
      e.preventDefault()
    } catch (error) {
      toast.error('Lỗi khi cập nhật zone!')
      console.error('Error updating zone:', error)
    }
  }

  onCreateZoneChange(e) {
    const { name, value } = e.target
    let createZoneInfo = { ...this.state.createZone }
    
    if (name === 'countries') {
      // Handle multiple select for countries
      const options = e.target.options
      const countries = []
      for (let i = 0; i < options.length; i++) {
        if (options[i].selected) {
          countries.push(options[i].value)
        }
      }
      createZoneInfo.countries = countries
    } else {
      createZoneInfo[name] = value
    }
    
    this.setState({ createZone: createZoneInfo })
  }

  onCreateZoneCountryChange(selectedOptions) {
    const countries = selectedOptions ? selectedOptions.map(option => option.value) : []
    this.setState({ 
      createZone: { 
        ...this.state.createZone, 
        countries 
      } 
    })
  }

  onEditZoneCountryChange(selectedOptions) {
    const countries = selectedOptions ? selectedOptions.map(option => option.value) : []
    this.setState({ 
      editZone: { 
        ...this.state.editZone, 
        countries 
      } 
    })
  }

  onEditZoneChange(e) {
    const { name, value } = e.target
    let editZoneInfo = { ...this.state.editZone }
    
    if (name === 'countries') {
      // Handle multiple select for countries
      const options = e.target.options
      const countries = []
      for (let i = 0; i < options.length; i++) {
        if (options[i].selected) {
          countries.push(options[i].value)
        }
      }
      editZoneInfo.countries = countries
    } else {
      editZoneInfo[name] = value
    }
    
    this.setState({ editZone: editZoneInfo })
  }

  openZoneEditModal(zone) {
    this.setState({
      editZone: {
        id: zone.id,
        name: zone.name,
        countries: JSON.parse(zone.countries || '[]'),
        note: zone.note || ''
      },
      modalZoneEditToggle: true
    })
  }

  onDeleteZone(zoneId, zoneName) {
    confirmAlert({
      title: 'Xác nhận xóa Zone',
      message: `Bạn có chắc chắn muốn xóa zone "${zoneName}"? Hành động này không thể hoàn tác.`,
      buttons: [
        {
          label: 'Xóa',
          onClick: async () => {
            try {
              await axios.delete(`/api/zones/${zoneId}`)
              
              // Refresh zones
              const tpeuService = this.state.services.find(service => 
                service.name.includes('TP-EU') || service.name.includes('TP - EU')
              )
              if (tpeuService) {
                await this.getZonesByService(tpeuService.id)
              }
              
              // Refresh zones for the service that owns this zone
              const zoneService = this.state.services.find(service => {
                const serviceZones = this.state.serviceZones[service.name] || []
                return serviceZones.some(z => z.id === zoneId)
              })
              if (zoneService) {
                await this.getZonesByServiceName(zoneService.name)
              }
              
              toast.success('Xóa zone thành công!')
            } catch (error) {
              toast.error('Lỗi khi xóa zone!')
              console.error('Error deleting zone:', error)
            }
          }
        },
        {
          label: 'Hủy',
          onClick: () => {}
        }
      ]
    })
  }

  onChange2 = (imageList, addUpdateIndex) => {
    // data for submit
    console.log(imageList, addUpdateIndex);
    this.setImages(imageList);
  };

  setImages(imageList) {
    this.setState({images: imageList})
  }

  onImageEditRemove = (index) => {
    let { imagesEdit } = this.state
    const filteredItems = imagesEdit.filter(item => item !== imagesEdit[index])
    this.setState({imagesEdit: filteredItems})
  }

  showDateTime(obj) {
    if (!obj.fromDate || !obj.toDate) return ''
    return `${moment(obj.fromDate).format('DD/MM/YYYY')} - ${moment(obj.toDate).format('DD/MM/YYYY')}`
  }

  onChooseFile(e) {
    this.setState({file: e.target.files[0]})
  }

  setKey = (key) => () => {
    console.log(key)
    this.setState({keySelected: key}, async () => {
      // Reload zone pricing when price type changes
      await this.loadZonePricingForAllZones()
      
      // Reload zones for TP services with new priceType filter
      const tpServices = this.state.services.filter(service => 
        service.name.includes('TP') || service.name.includes('RG - AU') || service.name.includes('RG-AU')
      )
      
      for (const service of tpServices) {
        await this.getZonesByServiceName(service.name)
      }
    })
    console.log(this.state.keySelected)
  }

  toggleImportCSVModal() {
    this.setState(prevState => ({ 
      modalImportCSVToggle: !prevState.modalImportCSVToggle,
      importCSVResult: null,
      importCSVFile: null
    }))
  }

  openImportCSVModal(serviceName) {
    const serviceType = serviceName.toUpperCase().includes('TOLL') ? 'AU-TOLL' : 'AUSPOST';
    this.setState({
      importCSVServiceName: serviceName,
      importCSVServiceType: serviceType,
      modalImportCSVToggle: true,
      importCSVResult: null,
      importCSVFile: null
    })
  }

  async onImportCSV() {
    const { importCSVFile, importCSVServiceType, importCSVServiceName } = this.state;
    if (!importCSVFile) {
      toast.error('Vui lòng chọn file CSV!');
      return;
    }
    
    this.setState({ importCSVLoading: true });
    
    const reader = new FileReader();
    reader.onload = async (event) => {
      try {
        const csvData = event.target.result;
        const res = await axios.post('/api/postcode-zones/import', {
          csvData,
          serviceType: importCSVServiceType,
          serviceName: importCSVServiceName
        });
        this.setState({ 
          importCSVResult: res.data,
          importCSVLoading: false 
        });
        toast.success(`Import thành công: ${res.data.imported} records`);
        
        // Reload zones for this service
        await this.getZonesByServiceName(importCSVServiceName);
      } catch (error) {
        console.error('Error importing CSV:', error);
        toast.error('Lỗi khi import CSV!');
        this.setState({ importCSVLoading: false });
      }
    };
    reader.readAsText(importCSVFile);
  }

  CSVstring_to_Array(fileContent, delimiter = ',') {
    const rows = fileContent.split('\n');
    const headers = rows[0].split(',');
    const headerArr = [];

    for (let i = 0; i < headers.length; i += 2) {
      const obj = {
        service: headers[i],
        type: headers[i + 1]
      };

      headerArr.push(obj);
    }
    console.log(headerArr)
    let data = []
    for (let k = 0; k < headerArr.length; k++) {
      let pricings = {}
      for (let i = 1; i < rows.length; i++) {
        const row = rows[i].split(',');
        if (row.length === 0) continue
        pricings = {...pricings, [row[k*2]]: row[k*2+1]?.toString()?.replace(/\./g, "")}
      }
      data.push({
        ...headerArr[k],
        pricings
      })
    }
    return data;
  };

  async uploadMoneyPricing() {
    const {file} = this.state
    let self = this
    if (!file) {
      toast.error('Vui lòng chọn file để upload')
      return
    }

    fileReader.readAsText(file);
    fileReader.onload = async function (event) {
      const csvOutput = event.target.result;
      let arr = self.CSVstring_to_Array(csvOutput)
      arr = arr.map(item => {
        return {
          priceType: item.type?.toUpperCase(),
          serviceName: item.service,
          moneyPricingId: self.state.moneyPricingDetail.id,
          priceJSON: JSON.stringify(item.pricings)
        }
      })

      try {
        await axios.post('/create-service-pricing', arr)
        toast.success('Upload bảng giá thành công')

        await self.getAllServicePricing()
      } catch (e) {
        toast.error('Upload bảng giá thất bại')
        console.error(e)
      }
    };
  }

  getPriceArr(data) {
    const { services, serviceSearchTerm } = this.state
    const arr = data.filter(item => item.priceType?.toLowerCase() === this.state.keySelected.toLowerCase())?.[0]
    
    // Filter services by search term
    let filteredServices = services
    if (serviceSearchTerm && serviceSearchTerm.trim() !== '') {
      filteredServices = services.filter(service => 
        service.name.toLowerCase().includes(serviceSearchTerm.toLowerCase())
      )
    }
    
    // Sort services to prioritize TP-EU services at the top
    const sortedServices = [...filteredServices].sort((a, b) => {
      const priorityServices = ['TP - EU', 'TP - EU HN']
      const aIndex = priorityServices.indexOf(a.name)
      const bIndex = priorityServices.indexOf(b.name)
      
      // If both are priority services, maintain their original order
      if (aIndex !== -1 && bIndex !== -1) {
        return aIndex - bIndex
      }
      // If only a is priority, put it first
      if (aIndex !== -1) return -1
      // If only b is priority, put it first
      if (bIndex !== -1) return 1
      // Neither are priority, maintain original order
      return 0
    })
    
    const response = sortedServices.map(item => {
      const curData = arr?.arr?.filter(item2 => item2.serviceName === item.name)?.[0] || []
      let sortedArr = []
      if (curData?.priceJSON) {
        let obj = JSON.parse(curData.priceJSON)
        const sortedKeys = Object.keys(obj).sort((a, b) => parseFloat(a) - parseFloat(b));
        sortedKeys.forEach(key => {
          sortedArr.push({key, value: obj[key]})
        });
      }
      return {
        ...item,
        arr: {...curData, sortedArr},
        hasData: sortedArr?.length > 0 || false
      }
    })
    console.log(response)
    return response

  }

  getJSONData(item) {

  }

  onUpdateServicePricingJSON(e) {
    const {name, value} = e.target;
    let createPricingInfo = this.state.servicePricingItem
    let pricings = createPricingInfo.priceJSON
    if (value) {
      const cleanedData = value.replace(/[\t\n]/g, ' ');
      const values = cleanedData.split(' ');
      console.log(values)
      const parsedData = {};
      for (let i = 0; i < values.length; i += 2) {
        const key = values[i];
        const value = values[i + 1]?.toString()?.replace(/\./g, "");
        if (key && value && !isNaN(value)) {
          parsedData[key] = value;
        }
      }
      pricings = pricings? JSON.parse(pricings) : {}
      pricings = {...pricings, ...parsedData}
      this.setState({servicePricingItem: {...createPricingInfo, priceJSON: JSON.stringify(pricings)}})
    }
  }

  render() {
    const {data} = this.state
    
    // Custom styles to match current theme
    const zoneHeaderStyle = {
      background: '#f8f9fa',
      borderRadius: '4px 4px 0 0',
      transition: 'all 0.3s ease',
      border: '1px solid #dee2e6'
    }
    
    const zoneCardStyle = {
      border: '1px solid #dee2e6',
      borderRadius: '4px',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      transition: 'box-shadow 0.3s ease',
      marginBottom: '12px'
    }
    
    const zoneHeaderHoverStyle = {
      background: '#e9ecef',
      transform: 'translateY(-1px)',
      boxShadow: '0 2px 6px rgba(0,0,0,0.15)'
    }
    
    return (
      <div>
        <ToastContainer
          position='top-right'
          autoClose={3000}
          hideProgressBar={true}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
        />
        <Breadcrumb>
          <BreadcrumbItem>TRANG </BreadcrumbItem>
          <BreadcrumbItem active>Chi tiết bảng giá</BreadcrumbItem>
        </Breadcrumb>
        <div className="card card-primary">
          <div className="card-header">{this.state.moneyPricingDetail.name}</div>
          <div className="card-body">
            <div className="row">
              <div className="col-md-6">
                <p><strong>Ngày áp dụng:</strong> {this.showDateTime(this.state.moneyPricingDetail)}</p>
                <p><strong>Ghi chú:</strong> {this.state.moneyPricingDetail.note}</p>
              </div>
              <div className="col-md-6">
                <FormGroup>
                  <Input onChange={e => this.onChooseFile(e)}
                         accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                         name="file" type="file" />
                </FormGroup>
                {this.state.currUser.email !== 'pricingtinphatexp@gmail.com' && (
                  <>
                    <Button type="button" color="primary" onClick={() => this.uploadMoneyPricing()}>Upload Bảng Giá</Button>
                    <a href="/pricing-sample.csv" className="text text-primary pl-3">Tải bảng giá mẫu .csv</a>
                  </>
                )}
              </div>
            </div>
          </div>

        </div>

        <div className="card card-primary">
          <div className="card-header">
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <Button className={`transparent p-2 mr-3`} color={`${this.state.keySelected.toLowerCase() ===  'sale' ? 'primary' : ''}`}  type="button" onClick={this.setKey('Sale')}>Giá Sale</Button>
                <Button className={`transparent p-2 mr-3`} color={`${this.state.keySelected.toLowerCase() ===  'f0'? 'primary' : ''}`}  type="button" onClick={this.setKey('F0')}>Giá Đại lý</Button>
              </div>
              <div className="d-flex align-items-center" style={{ maxWidth: '300px' }}>
                <div className="input-group">
                  <Input
                    type="text"
                    placeholder="Tìm kiếm dịch vụ..."
                    value={this.state.serviceSearchTerm}
                    onChange={this.onServiceSearchChange}
                    className="form-control-sm"
                  />
                  {this.state.serviceSearchTerm && (
                    <div className="input-group-append">
                      <Button 
                        color="secondary" 
                        size="sm" 
                        onClick={this.clearServiceSearch}
                        style={{ borderRadius: '0 4px 4px 0' }}
                      >
                        <i className="fa fa-times"></i>
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="pt-2">
            {this.state.serviceSearchTerm && (
              <div className="mb-3 px-3">
                <small className="text-muted">
                  <i className="fa fa-search mr-1"></i>
                  Tìm thấy {this.getPriceArr(data)?.length || 0} dịch vụ cho "{this.state.serviceSearchTerm}"
                  {this.getPriceArr(data)?.length === 0 && (
                    <span className="text-danger ml-2">
                      - Không tìm thấy dịch vụ nào
                    </span>
                  )}
                  <Button 
                    size="sm" 
                    color="link" 
                    className="p-0 ml-2" 
                    onClick={this.clearServiceSearch}
                  >
                    Hiển thị tất cả
                  </Button>
                </small>
              </div>
            )}
            <Row>
              {
                this.getPriceArr(data)?.map((item, index) => {
                  return (
                    <Col md={6} key={index}>
                      <div className="card" style={{ marginBottom: '10px' }}>
                        <div className="card-header" style={{ 
                          backgroundImage: 'none',
                          borderRadius: '0px 20px 0px 0px',
                          backgroundColor: '#f5f5f5'
                        }}>
                          <h5 className="w-100 card-title text-uppercase d-flex justify-content-between align-items-center text-center" style={{ 
                            margin: 0, 
                            fontWeight: '500', 
                            color: '#000000' 
                          }}>
                            <strong style={{ color: '#000000' }}>{item.name}</strong>
                            <div className="d-flex">
                              {this.state.currUser.email !== 'pricingtinphatexp@gmail.com' && (
                                <>
                                  {(item.name.includes('TP - EU') || item.name.includes('TP-EU')) && (
                                    <Button 
                                      size="sm" 
                                      color="success" 
                                      className="mr-2"
                                      onClick={() => this.selectZoneForService(item.name)}
                                    >
                                      + Zone
                                    </Button>
                                  )}
                                  {(item.name.includes('RG - AU') || item.name.includes('RG-AU')) && (
                                    <Button 
                                      size="sm" 
                                      color="info" 
                                      className="mr-2"
                                      onClick={() => this.openImportCSVModal(item.name)}
                                    >
                                      📂 Import CSV Zone
                                    </Button>
                                  )}
                                  {!(item.name.includes('TP - EU') || item.name.includes('TP-EU')) && (
                                    <Link to={`/app/edit-manage-pricing-detail/${this.props.match.params.moneyPricingId}/${item.name}/${this.state.keySelected}`} className={'p-2'} style={{ color: '#000000' }}>
                                      <i className="fa fa-pencil" />
                                    </Link>
                                  )}
                                </>
                              )}
                            </div>
                          </h5>
                        </div>
                        <div className="card-body p-0">
                          {/* Default pricing table with collapse - only show if has data */}
                          {item.hasData && (
                            <div className="mb-3">
                              <div 
                                className="d-flex justify-content-between align-items-center bg-light p-2 m-0"
                                style={{ cursor: 'pointer', borderRadius: '4px 4px 0 0' }}
                                onClick={() => this.toggleDefaultPricingCollapse(item.name)}
                              >
                                <div className="d-flex align-items-center">
                                  <i className={`fa ${this.state.collapsedDefaultPricing[item.name] ? 'fa-chevron-right' : 'fa-chevron-down'} mr-2`}></i>
                                  <h6 className="m-0">Bảng giá mặc định</h6>
                                  {(() => {
                                    if (item.arr?.sortedArr && item.arr.sortedArr.length > 0) {
                                      const priceCount = item.arr.sortedArr.length
                                      return (
                                        <span className={`badge ml-2 ${priceCount > 0 ? 'badge-success' : 'badge-warning'}`}>
                                          <i className="fa fa-tags mr-1"></i>
                                          {priceCount} prices
                                        </span>
                                      )
                                    } else if (item.hasData) {
                                      return (
                                        <span className="badge badge-warning ml-2">
                                          <i className="fa fa-exclamation-triangle mr-1"></i>
                                          No prices
                                        </span>
                                      )
                                    }
                                    return null
                                  })()}
                                </div>
                                <small className="text-muted">
                                  {this.state.collapsedDefaultPricing[item.name] ? 'Click to expand' : 'Click to collapse'}
                                </small>
                              </div>
                              <Collapse isOpen={!this.state.collapsedDefaultPricing[item.name]}>
                                <Table bordered style={{ marginBottom: 0 }}>
                                  <thead>
                                  <tr>
                                    <th className={'text-center'}>Số Kg</th>
                                    <th className={'text-center'}>Giá tiền</th>
                                  </tr>
                                  </thead>
                                  <tbody>
                                  {
                                    item.arr?.sortedArr ? item.arr.sortedArr.map((priceItem, priceIndex) => {
                                      return (
                                        <tr key={priceIndex}>
                                          <td className={'text-center'}>Giá {this.formatKey(priceItem.key)} kg</td>
                                          <td className={'text-center'}>{this.formatNumber(priceItem.value)}</td>
                                        </tr>
                                      )
                                    }) : <tr><td colSpan={2} className={'text-center'}>Chưa có dữ liệu</td></tr>
                                  }
                                  </tbody>
                                </Table>
                              </Collapse>
                            </div>
                          )}
                          
                          {/* Zone-based pricing tables */}
                          {this.state.serviceZones[item.name] && this.state.serviceZones[item.name].length > 0 && (
                            <div>
                              <div 
                                className="d-flex justify-content-between align-items-center p-3 m-0"
                                style={{ ...zoneHeaderStyle, cursor: 'pointer' }}
                                onClick={() => this.toggleSectionCollapse(item.name)}
                                onMouseEnter={(e) => {
                                  e.target.style.background = '#e9ecef'
                                  e.target.style.transform = 'translateY(-1px)'
                                  e.target.style.boxShadow = '0 2px 6px rgba(0,0,0,0.15)'
                                }}
                                onMouseLeave={(e) => {
                                  e.target.style.background = '#f8f9fa'
                                  e.target.style.transform = 'translateY(0)'
                                  e.target.style.boxShadow = 'none'
                                }}
                              >
                                <div className="d-flex align-items-center">
                                  <i className={`fa ${this.state.collapsedSections[item.name] ? 'fa-chevron-right' : 'fa-chevron-down'} mr-3 text-dark`} style={{ fontSize: '16px' }}></i>
                                  <div>
                                    <h6 className="m-0 text-dark" style={{ fontSize: '18px', fontWeight: '600' }}>
                                      Bảng giá theo Zone
                                    </h6>
                                    <small className="text-muted">
                                      {this.state.serviceZones[item.name].length} zones available
                                    </small>
                                  </div>
                                </div>
                                <div className="d-flex align-items-center">
                                  <Button
                                    size="sm"
                                    color="secondary"
                                    outline
                                    className="mr-2"
                                    onClick={(e) => {
                                      e.stopPropagation()
                                      // Toggle all zones in this service
                                      const allCollapsed = this.state.serviceZones[item.name].every(z => this.state.collapsedZones[z.id])
                                      const newState = {}
                                      this.state.serviceZones[item.name].forEach(z => {
                                        newState[z.id] = !allCollapsed
                                      })
                                      this.setState(prevState => ({
                                        collapsedZones: { ...prevState.collapsedZones, ...newState }
                                      }))
                                    }}
                                  >
                                    <i className="fa fa-expand-arrows-alt mr-1"></i>
                                    {this.state.serviceZones[item.name].every(z => this.state.collapsedZones[z.id]) ? 'Expand All' : 'Collapse All'}
                                  </Button>
                                  <small className="text-muted">
                                    {this.state.collapsedSections[item.name] ? 'Click to expand' : 'Click to collapse'}
                                  </small>
                                </div>
                              </div>
                              <Collapse isOpen={!this.state.collapsedSections[item.name]}>
                                <div className="border border-top-0 p-2">
                                  {this.state.serviceZones[item.name].map((zone, zoneIndex) => (
                                    <div key={zone.id} style={zoneCardStyle}>
                                      <div 
                                        className="d-flex justify-content-between align-items-center bg-light p-3 rounded-top"
                                        style={{ 
                                          cursor: 'pointer',
                                          background: '#f8f9fa',
                                          borderBottom: '1px solid #dee2e6',
                                          transition: 'all 0.3s ease'
                                        }}
                                        onClick={() => this.toggleZoneCollapse(zone.id)}
                                        onMouseEnter={(e) => {
                                          e.target.style.background = '#e9ecef'
                                        }}
                                        onMouseLeave={(e) => {
                                          e.target.style.background = '#f8f9fa'
                                        }}
                                      >
                                        <div className="d-flex align-items-center">
                                          <i className={`fa ${this.state.collapsedZones[zone.id] ? 'fa-chevron-right' : 'fa-chevron-down'} mr-2 text-dark`}></i>
                                          <div>
                                            <strong className="text-dark">{zone.name}</strong>
                                            <br/>
                                            <small className="text-muted">{JSON.parse(zone.countries || '[]').join(', ')}</small>
                                          </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                          {(() => {
                                            const zonePricingData = this.state.zonePricing[zone.id]
                                            if (zonePricingData && zonePricingData.priceJSON) {
                                              try {
                                                const prices = JSON.parse(zonePricingData.priceJSON)
                                                const priceCount = Object.keys(prices).length
                                                return (
                                                  <span className={`badge mr-2 ${priceCount > 0 ? 'badge-success' : 'badge-warning'}`}>
                                                    <i className="fa fa-tags mr-1"></i>
                                                    {priceCount} prices
                                                  </span>
                                                )
                                              } catch (e) {
                                                return (
                                                  <span className="badge badge-danger mr-2">
                                                    <i className="fa fa-exclamation-triangle mr-1"></i>
                                                    Error
                                                  </span>
                                                )
                                              }
                                            }
                                            return (
                                              <span className="badge badge-secondary mr-2">
                                                <i className="fa fa-plus mr-1"></i>
                                                No pricing
                                              </span>
                                            )
                                          })()}
                                          {this.state.currUser.email !== 'pricingtinphatexp@gmail.com' && (
                                            <>
                                              <Link 
                                                to={`/app/edit-manage-pricing-detail/${this.props.match.params.moneyPricingId}/${zone.name}/${this.state.keySelected}?zoneId=${zone.id}`}
                                                className="btn btn-sm btn-outline-primary mr-1"
                                                onClick={(e) => e.stopPropagation()}
                                              >
                                                <i className="fa fa-edit" />
                                              </Link>
                                              <Button 
                                                size="sm" 
                                                color="outline-danger"
                                                onClick={(e) => {
                                                  e.stopPropagation()
                                                  this.onDeleteZone(zone.id, zone.name)
                                                }}
                                              >
                                                <i className="fa fa-trash" />
                                              </Button>
                                            </>
                                          )}
                                        </div>
                                      </div>
                                      <Collapse isOpen={!this.state.collapsedZones[zone.id]}>
                                        <div className="p-3">
                                        <Table 
                                          bordered 
                                          size="sm" 
                                          className="mb-0"
                                          style={{ 
                                            borderRadius: '6px', 
                                            overflow: 'hidden',
                                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                                          }}
                                        >
                                    <thead>
                                    <tr>
                                      <th className={'text-center'}>Số Kg</th>
                                      <th className={'text-center'}>Giá tiền</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                      {(() => {
                                        const zonePricingData = this.state.zonePricing[zone.id]
                                        if (zonePricingData && zonePricingData.priceJSON) {
                                          try {
                                            const prices = JSON.parse(zonePricingData.priceJSON)
                                            const priceEntries = Object.entries(prices).sort((a, b) => parseFloat(a[0]) - parseFloat(b[0]))
                                            
                                            if (priceEntries.length === 0) {
                                              return (
                                                <tr>
                                                  <td colSpan={2} className={'text-center text-muted'}>
                                                    Chưa có giá zone - Nhấn Edit để cập nhật
                                                  </td>
                                                </tr>
                                              )
                                            }
                                            
                                            return priceEntries.map(([weight, price], index) => (
                                              <tr key={index}>
                                                <td className={'text-center'}>{weight} kg</td>
                                                <td className={'text-right'}>{parseInt(price).toLocaleString('vi-VN')} VND</td>
                                              </tr>
                                            ))
                                          } catch (e) {
                                            console.error('Error parsing zone pricing JSON:', e)
                                            return (
                                              <tr>
                                                <td colSpan={2} className={'text-center text-muted'}>
                                                  Lỗi hiển thị giá zone
                                                </td>
                                              </tr>
                                            )
                                          }
                                        } else {
                                          return (
                                            <tr>
                                              <td colSpan={2} className={'text-center text-muted'}>
                                                Chưa có giá zone - Nhấn Edit để cập nhật
                                              </td>
                                            </tr>
                                          )
                                        }
                                      })()}
                                          </tbody>
                                          </Table>
                                        </div>
                                      </Collapse>
                                    </div>
                                  ))}
                                </div>
                              </Collapse>
                            </div>
                          )}
                        </div>
                      </div>
                    </Col>
                  )
                })
              }

            </Row>
          </div>
        </div>


        {/* Zone Create Modal */}
        <Modal isOpen={this.state.modalZoneToggle} toggle={this.toggleZoneModal}>
          <Form>
            <ModalHeader toggle={this.toggleZoneModal}>
              Thêm Zone mới - {this.state.selectedServiceForZone}
              <div className="text-muted small mt-1">
                Price Type: <span className="badge badge-info">{this.state.keySelected?.toUpperCase() || 'SALE'}</span>
              </div>
            </ModalHeader>
            <ModalBody>
              <FormGroup>
                <Label for="zoneName">Tên Zone *</Label>
                <Input 
                  type="text" 
                  name="name" 
                  id="zoneName" 
                  value={this.state.createZone.name}
                  placeholder="Ví dụ: EU Zone 1, EU Zone 2..." 
                  onChange={this.onCreateZoneChange}
                />
              </FormGroup>
              <FormGroup>
                <Label for="zoneCountries">Chọn Quốc gia *</Label>
                <Select
                  id="zoneCountries"
                  name="countries"
                  isMulti
                  value={this.state.CountriesOptions.filter(option => 
                    this.state.createZone.countries.includes(option.value)
                  )}
                  options={this.state.CountriesOptions}
                  styles={{
                    control: (styles) => ({
                      ...styles,
                      borderColor: (!this.state.createZone.countries || this.state.createZone.countries.length === 0) 
                        ? 'red' 
                        : styles.borderColor,
                      height: 'auto',
                      minHeight: 'calc(1.5em + 0.75rem + 2px)',
                      borderRadius: 0,
                    }),
                    multiValue: (styles) => ({
                      ...styles,
                      backgroundColor: '#e9ecef',
                    }),
                  }}
                  onChange={this.onCreateZoneCountryChange}
                  placeholder="Chọn các quốc gia..."
                />
                <small className="text-muted">Chọn nhiều quốc gia cho zone này</small>
              </FormGroup>
              <FormGroup>
                <Label for="zoneNote">Ghi chú</Label>
                <Input 
                  type="textarea" 
                  name="note" 
                  id="zoneNote" 
                  value={this.state.createZone.note}
                  placeholder="Ghi chú về zone này..." 
                  onChange={this.onCreateZoneChange}
                />
              </FormGroup>
            </ModalBody>
            <ModalFooter>
              <Button color="primary" onClick={this.onCreateZone}>Tạo Zone</Button>
              <Button color="secondary" onClick={this.toggleZoneModal}>Hủy</Button>
            </ModalFooter>
          </Form>
        </Modal>

        {/* Zone Edit Modal */}
        <Modal isOpen={this.state.modalZoneEditToggle} toggle={this.toggleZoneEditModal}>
          <Form>
            <ModalHeader toggle={this.toggleZoneEditModal}>
              Chỉnh sửa Zone
              <div className="text-muted small mt-1">
                Price Type: <span className="badge badge-info">{this.state.keySelected?.toUpperCase() || 'SALE'}</span>
              </div>
            </ModalHeader>
            <ModalBody>
              <FormGroup>
                <Label for="editZoneName">Tên Zone *</Label>
                <Input 
                  type="text" 
                  name="name" 
                  id="editZoneName" 
                  value={this.state.editZone.name}
                  placeholder="Ví dụ: EU Zone 1, EU Zone 2..." 
                  onChange={this.onEditZoneChange}
                />
              </FormGroup>
              <FormGroup>
                <Label for="editZoneCountries">Chọn Quốc gia *</Label>
                <Select
                  id="editZoneCountries"
                  name="countries"
                  isMulti
                  value={this.state.CountriesOptions.filter(option => 
                    this.state.editZone.countries.includes(option.value)
                  )}
                  options={this.state.CountriesOptions}
                  styles={{
                    control: (styles) => ({
                      ...styles,
                      borderColor: (!this.state.editZone.countries || this.state.editZone.countries.length === 0) 
                        ? 'red' 
                        : styles.borderColor,
                      height: 'auto',
                      minHeight: 'calc(1.5em + 0.75rem + 2px)',
                      borderRadius: 0,
                    }),
                    multiValue: (styles) => ({
                      ...styles,
                      backgroundColor: '#e9ecef',
                    }),
                  }}
                  onChange={this.onEditZoneCountryChange}
                  placeholder="Chọn các quốc gia..."
                />
                <small className="text-muted">Chọn nhiều quốc gia cho zone này</small>
              </FormGroup>
              <FormGroup>
                <Label for="editZoneNote">Ghi chú</Label>
                <Input 
                  type="textarea" 
                  name="note" 
                  id="editZoneNote" 
                  value={this.state.editZone.note}
                  placeholder="Ghi chú về zone này..." 
                  onChange={this.onEditZoneChange}
                />
              </FormGroup>
            </ModalBody>
            <ModalFooter>
              <Button color="primary" onClick={this.onEditZone}>Cập nhật Zone</Button>
              <Button color="secondary" onClick={this.toggleZoneEditModal}>Hủy</Button>
            </ModalFooter>
          </Form>
        </Modal>

        <Modal isOpen={this.state.modalToggle} toggle={this.toggle}>
          <Form>
            <ModalHeader toggle={this.toggle}>
              Cập nhật giá cho dịch vụ
              <div className={'mt-2'}>{this.state.servicePricingItem?.name || ''} - Giá {this.state.servicePricingItem?.priceType || ''}</div>
            </ModalHeader>
            <ModalBody>
              <FormGroup>
                <Label for="note">Dán mã vào bên dưới</Label>
                <Input type="textarea" name="note" rows={8} id="note" placeholder="0.5 900.000"
                       onChange={this.onUpdateServicePricingJSON}/>
              </FormGroup>
              <note>
                <p>Chú ý: Cập nhật mã với định dạng <strong>[Số Kg] [Giá tiền]</strong></p>
              </note>
            </ModalBody>
            <ModalFooter>
              <Button color="primary" onClick={(e) => this.onUpdateServicePricing(e)}>Create</Button>{' '}
              <Button color="secondary" onClick={this.toggle}>Cancel</Button>
            </ModalFooter>
          </Form>
        </Modal>

        {/* Import CSV Modal */}
        <Modal isOpen={this.state.modalImportCSVToggle} toggle={this.toggleImportCSVModal}>
          <ModalHeader toggle={this.toggleImportCSVModal}>
            Import CSV Zone - {this.state.importCSVServiceName}
            <div className="text-muted small mt-1">
              Service Type: <span className="badge badge-info">{this.state.importCSVServiceType}</span>
            </div>
          </ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label>Chọn file CSV</Label>
              <Input 
                type="file" 
                accept=".csv"
                onChange={(e) => this.setState({ importCSVFile: e.target.files[0] })}
              />
              <small className="text-muted">
                Format: Semicolon-separated CSV với cột Postcode, State, Zone Number
              </small>
            </FormGroup>
            {this.state.importCSVResult && (
              <div className="alert alert-success">
                <strong>Import thành công!</strong>
                <ul className="mb-0 mt-1">
                  <li>Records imported: <strong>{this.state.importCSVResult.imported}</strong></li>
                  <li>Zones created: <strong>{this.state.importCSVResult.zonesCreated}</strong></li>
                  <li>Zone numbers: {this.state.importCSVResult.zoneNumbers?.join(', ')}</li>
                </ul>
              </div>
            )}
          </ModalBody>
          <ModalFooter>
            <Button 
              color="primary" 
              onClick={() => this.onImportCSV()}
              disabled={this.state.importCSVLoading}
            >
              {this.state.importCSVLoading ? 'Đang import...' : 'Import'}
            </Button>
            <Button color="secondary" onClick={this.toggleImportCSVModal}>Đóng</Button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

export default ManagePricingDetailDetail
